import { createSlice } from "@reduxjs/toolkit";
import { fetchAllUsers } from "services/user-select.service";

const UsersSlice = createSlice({
  name: "users",
  initialState: {
    usersCollection: [],
    isLoading: true,
    isError: false,
    errMsg: null,
    queryValue: null,
    // The users page opens on the active people.
    filtersValue: { isDisabled: ["not_disabled"] },
  },
  /* eslint-disable no-param-reassign */
  reducers: {
    setLoading(state) {
      state.isLoading = true;
      state.isError = false;
    },
    setUsers(state, action) {
      state.isLoading = false;
      state.usersCollection = action.payload.usersCollection;
    },
    setError(state, action) {
      state.isLoading = false;
      state.isError = true;
      // The old list belongs to other filters; the error takes its place.
      state.usersCollection = [];
      state.errMsg = action.payload.errMsg;
    },
    setFilterValue(state, action) {
      const { key, value } = action.payload;
      state.filtersValue[key] = value;
    },
  },
  /* eslint-enable */
});

// Extract the action creators object and the reducer
const { actions, reducer } = UsersSlice;

// Extract and export each action creator by name
export const { setLoading, setUsers, setError, setFilterValue } = actions;

// Export the reducer, either as a default or named export
export default reducer;

// Quick filter clicks start overlapping requests; only the newest may fill the list.
let latestRequestId = 0;

export const fetchUsers =
  (companyId, filtersValue, source) => async (dispatch) => {
    latestRequestId += 1;
    const requestId = latestRequestId;
    dispatch(setLoading());
    try {
      const { usersCollection } = await fetchAllUsers(
        companyId,
        filtersValue,
        source
      );
      if (requestId === latestRequestId) dispatch(setUsers({ usersCollection }));
    } catch (e) {
      if (requestId === latestRequestId) dispatch(setError({ errMsg: "" }));
    }
  };
